import { Card, CardContent, Box, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface FormSectionProps {
  title: React.ReactNode;
  icon: React.ReactElement;
  children: React.ReactNode;
  action?: React.ReactNode;
  sx?: SxProps<Theme>;
}

const FormSection: React.FC<FormSectionProps> = ({ title, icon, children, action, sx }) => (
  <Card variant="outlined" sx={{ mb: 2, ...sx }}>
    <CardContent>
      <Box display="flex" alignItems="center" justifyContent={action ? 'space-between' : undefined} mb={action ? 2 : 1}>
        <Box display="flex" alignItems="center">
          <Box sx={{ mr: 1, color: '#8600e1', display: 'flex' }}>{icon}</Box>
          <Typography variant="h6">
            {title}
          </Typography>
        </Box>
        {action && <Box ml="10px">{action}</Box>}
      </Box>
      {children}
    </CardContent>
  </Card>
);

export default FormSection;
